import { Case } from 'services';
export const CaseAudioMock: Case[] = [
  {
    id: 'CA-001',
    tenant: {
      tenantId: '488296E409C5C8B9',
      displayName: 'XboxLive',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4B',
      displayName: 'Test'
    },
    subject: {
      subjectId: '1',
      subjectType: 'Audio',
      subjectValue: 'https://www.w3schools.com/tags/horse.ogg',
      subjectLabels: [],
      subjectOwners: [
        {
          userId: '0001',
          userType: 'Xuid',
          username: 'testgamertag1'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      url: 'localhost.com',
      type: 'mp4'
    },
    caseCreationDateTime: '2019-11-07T19:35:52.1725026Z',
    caseAssignedStartTime: '2019-11-07T19:35:52.1728898Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {
      type: 'username',
      payload: {
        id: 'cid-00000000566b6c4c',
        username: 'Test First Test last',
        locale: '',
        profileImageUri:
          'https://cid-00000000566b6c4c.users.storage.live.com/users/0x00000000566b6c4c/myprofile/expressionprofile/profilephoto:Win8Static,UserTileMedium,UserTileStatic/MeControlXXLUserTile?ck=1&ex=24'
      }
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CA-002',
    tenant: {
      tenantId: '488296E409C5C8B9',
      displayName: 'XboxLive',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4B',
      displayName: 'Test'
    },
    subject: {
      subjectId: '2',
      subjectType: 'Audio',
      subjectValue: 'https://www.w3schools.com/tags/horse.ogg',
      subjectLabels: [],
      subjectOwners: [
        {
          userId: '0001',
          userType: 'Xuid',
          username: 'testgamertag1'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      url: 'localhost.com',
      type: 'mp4'
    },
    caseCreationDateTime: '2019-11-07T19:35:52.1725026Z',
    caseAssignedStartTime: '2019-11-07T19:35:52.1728898Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {
      type: 'username',
      payload: {
        id: 'cid-00000000566b6c4c',
        username: 'Test First Test last',
        locale: '',
        profileImageUri:
          'https://cid-00000000566b6c4c.users.storage.live.com/users/0x00000000566b6c4c/myprofile/expressionprofile/profilephoto:Win8Static,UserTileMedium,UserTileStatic/MeControlXXLUserTile?ck=1&ex=24'
      }
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
